import { Controller } from "@hotwired/stimulus"

const MD_BREAKPOINT = "(min-width: 768px)"

// Mirrors CSS visibility into inert/aria-hidden so only the active
// mobile or desktop course-row representation is exposed to AT.
export default class extends Controller {
  connect() {
    this.mediaQuery = window.matchMedia(MD_BREAKPOINT)
    this.boundSync = this.sync.bind(this)
    this.mediaQuery.addEventListener("change", this.boundSync)
    window.addEventListener("resize", this.boundSync)
    this.sync()
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.boundSync)
    window.removeEventListener("resize", this.boundSync)
  }

  sync() {
    const mobileCells = this.element.querySelectorAll(
      "[data-educator-home-page-course-monitoring-responsive='mobile']"
    )
    const desktopCells = this.element.querySelectorAll(
      "[data-educator-home-page-course-monitoring-responsive='desktop']"
    )

    mobileCells.forEach((cell) => this.setHiddenFromAssistiveTech(cell, this.isLayoutHidden(cell)))
    desktopCells.forEach((cell) => this.setHiddenFromAssistiveTech(cell, this.isLayoutHidden(cell)))
  }

  isLayoutHidden(element) {
    if (!element) return true

    const display = window.getComputedStyle(element).display
    if (display === "none") return true

    if (this.hasCssVisibilityDistinction()) return false

    const desktopActive = this.mediaQuery.matches
    return this.isMobileCell(element) ? desktopActive : !desktopActive
  }

  hasCssVisibilityDistinction() {
    const mobile = this.element.querySelector("[data-educator-home-page-course-monitoring-responsive='mobile']")
    const desktop = this.element.querySelector("[data-educator-home-page-course-monitoring-responsive='desktop']")
    if (!mobile || !desktop) return false

    return (
      window.getComputedStyle(mobile).display === "none" ||
      window.getComputedStyle(desktop).display === "none"
    )
  }

  isMobileCell(element) {
    return element.dataset.educatorHomePageCourseMonitoringResponsive === "mobile"
  }

  setHiddenFromAssistiveTech(element, hidden) {
    if (!element) return

    if (hidden) {
      element.setAttribute("inert", "")
      element.setAttribute("aria-hidden", "true")
    } else {
      element.removeAttribute("inert")
      element.removeAttribute("aria-hidden")
    }
  }
}
